import { guideButtonHtml } from "../../elements/button/component.js";
import { withDataAttrFallback } from "../../helpers/attributes-with-data-fallback.js";
import { validate } from "../../helpers/validate.js";
import { attributesButtonSchema } from "./attributes.js";
const scalarButton = {
  name: "scalar-button",
  tagName: "scalar-button",
  tiptapName: "custom_button",
  attributeTransform: (_, _attrs) => {
    const attrs = withDataAttrFallback(_attrs);
    return validate(attributesButtonSchema, {
      title: attrs.title || "",
      href: attrs.href || "",
      icon: attrs.icon || "",
      "icon-dark": attrs["icon-dark"] || ""
    });
  },
  render: guideButtonHtml
};
import { ScalarButtonVue } from "./component.js";
export {
  ScalarButtonVue,
  scalarButton
};
//# sourceMappingURL=index.js.map
